"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagKey = exports.FlagrBaseUrl = void 0;
var FlagrBaseUrl;
(function (FlagrBaseUrl) {
    FlagrBaseUrl["STAGING"] = "https://flagr-staging.getgrover.com/api/v1";
    FlagrBaseUrl["PRODUCTION"] = "https://flagr.getgrover.com/api/v1";
})(FlagrBaseUrl || (exports.FlagrBaseUrl = FlagrBaseUrl = {}));
var FeatureFlagKey;
(function (FeatureFlagKey) {
    FeatureFlagKey["ZENDESK"] = "zendesk_customer_support";
})(FeatureFlagKey || (exports.FeatureFlagKey = FeatureFlagKey = {}));
//# sourceMappingURL=constants.js.map